export default __webpack_public_path__ + "static/media/organizations.391d4932.svg";